import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import ShopForm from './forms/ShopForm';
import ShopList from './lists/ShopList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import TimeConfigEditor from "./TimeConfigEditor";
import ModalEditor from "./ModalEditor";

class ShopEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Boltok"
                >
                    <ShopList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Bolt"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    ]}
                >
                    <ShopForm {...this.props} />
                </Editor>
                {
                    this.props.values[this.props.componentConfig.idfield] && this.props.componentConfig.fielddefs.articles
                    &&
                    <Box
                        theme="default"
                        header="Kapcsolódó cikkek"
                    >
                        <SelectorGrid
                            columns={{
                                "headline": {header: 'Cím', width: 2, sortable: true, filterable: true}
                            }}
                            name={"articles"}
                            listfieldlabel={"headline"}
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            {...this.props.getFieldProps("articles")}
                        />
                    </Box>
                }
                {
                    this.props.values[this.props.componentConfig.idfield] &&
                    <TimeConfigEditor
                        gridid={"ShopTimeConfigList"}
                        presets={{location: {id: this.props.values.location_id}, program: null}}
                        isLoading={this.props.isLoading}
                        editor={ModalEditor}
                        selection={null}
                        listFilter={[
                            {
                                field: "location",
                                value: this.props.values.location_id
                            },
                            {
                                field: "program",
                                operator: "isnull"
                            },
                        ]}
                    />
                }
        </Fragment>;
    }
}

export default createEditor({
    componentName: "Shop",
    WrappedComponent: ShopEditor,
    props: {
        view: "admin"
    }
});
